module.exports = __webpack_public_path__ + "media/red-winged-blackbird-2.d9e7bdf1.mp3";